module.exports = __webpack_public_path__ + "static/system-state-flow-disassembling-@2x-4afcede28e5c7f4270757de13ceccc09.jpg";